import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import {
  useDisclosure,
  VStack,
  Grid,
  Box,
  Flex,
  Spacer,
  useToast,
  Text,
  Divider,
  Button,
  Icon,
  Switch
} from "@chakra-ui/react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { format } from "date-fns";

import { FaFileCsv } from "react-icons/fa";

import CreateCaseButton from "../merchant-list/create-case-button-renderer";
import CreateCaseForm from "../Cases/create-case-form";
import Sidebar from "../sections/Sidebar/Sidebar";
import CaseService from "../../services/cases.service";
import BreadCrumbs from "../common/BreadCrumbs";
import Loader from '../common/Loader'; 
import Header from  '../sections/Header';
import CommentSearch from "./CommentSearch";
import CaseAction from "./CaseAction";
import DateRangeSelectorForWeeklyView from "./DateRangeSelectorForWeeklyView";

import { thousandSeparator } from "../../utils/utilities";
import { filterParams, dateComparator } from '../../utils/ag-grid';
import { getCountryNameWithCountryCode } from '../../config/static/country';

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./case.css";


const ListCasesWeeklyGroup = () => {
  const toast = useToast();
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedcase, setselectedCase] = useState({});
  const [caseData, setRowData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  // const [validationErrors, setValidationErrors] = useState({startDate: "", endDate: "" });
  const [actionList, setActionList] = useState([ { label: "Select the action", value: "" }]);
  const [dateColumns, setDateColumns] = useState([]);
  const preferences = JSON.parse(localStorage.getItem("preferences"));
  const [oldCaseData,setOldCaseData] = useState([]);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const caseView = preferences.caseView;

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false,
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };
  const openModal = (data) => {
    if (!data || !data._id || !data.merchantObjID) {
      toast({
        title: "Invalid row selected.",
        position: "top",
        status: "warning",
        isClosable: true,
      });
      return;
    }
    setselectedCase({ _id: data.merchantObjID, case: [{ _id: data._id }] });
    onOpen();
  };

  const fetchData = async (startDate = null, endDate = null) => {
    setisLoading(true);
    let result;
    if (!startDate && !endDate) {
      result = await CaseService.fetchByWeeklyGroupData({});
    } else {
      result = await CaseService.fetchByWeeklyGroupData({ startDate, endDate });
    }
    if (result.error) {
      setisLoading(false);
      toast({
        title: result.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      return;
    }
    if (result.warning) {
      setisLoading(false);
      toast({
        title: result.warning,
        position: "top",
        status: "warning",
        isClosable: true,
      });
      return;
    }
    //console.log(result);
    setRowData(result.data);
    setOldCaseData(result.data);
    // setStartDate(new Date(result.startDate));
    // setEndDate(new Date(result.endDate));
    setisLoading(false);
  };

  useEffect(() => {
    setActionList((prev) => [...prev, { label: "EDIT", value: "EDIT" }]);
    let user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    // if (user.user && user.user.email) setEmail(user.user.email);
    if (user.user && user.user.role && user.user.permissions.includes('deleteCase'))
      setActionList((prev) => [...prev, { label: "DELETE", value: "DELETE" }]);
    fetchData();
    setDateColumns(
      caseView.reduce((c, i) => {
        if (i.type === "date") return [...c, i.value];
        return c;
      }, [])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // const getData = (startDate, endDate) => {
  //   if (!startDate || !endDate) {
  //     if (!startDate)
  //       setValidationErrors((prev) => {
  //         return { ...prev, startDate: "Start date required.!" };
  //       });
  //     if (!endDate)
  //       setValidationErrors((prev) => {
  //         return { ...prev, endDate: "End date required.!" };
  //       });
  //     return;
  //   }
  //   if (startDate > endDate) {
  //     setValidationErrors((prev) => {
  //       return { ...prev, endDate: "End date mustbe less than start date!" };
  //     });
  //     setEndDate(null);
  //   }
  //   fetchData(startDate, endDate);
  // };

  const dynamicCellStyle = (params) => {
    const ret = { textAlign: "centre" };
    if (
      typeof params.data[params["colDef"].field] !== "undefined" &&
      params.data[params["colDef"].field].hasOwnProperty("bg")
    )
      return {
        ...ret,
        backgroundColor: params.data[params["colDef"].field].bg,
      };
    return ret;
  };
  const cellUpdateForDate = (props) => {
    // const field = props["colDef"]["field"];
    if (typeof props["value"] !== "undefined") {
      let value = format(new Date(props["value"]), "dd-MMM-yyyy");
      return value;
    }
    return;
  };
  const cellUpdateForCountry = (props) => {
    return getCountryNameWithCountryCode(props["value"]);
  };

  //this will update the current edited row with updated data.
  const updateCase = (casedata) => {
    let updatedCase = gridApi.getRowNode(casedata._id).data;
    updatedCase["status"] = casedata.status;
    updatedCase["reminderDate"] = casedata.reminderDate;
    updatedCase["manager"] = casedata.manager;
    updatedCase["selectedColumns"] = casedata.selectedColumns;
    gridApi.getRowNode(casedata._id).setData(updatedCase);
    gridApi.redrawRows();
    return;
  };

  const exportAsCSV = () => {
    toast({
      title: "Downloading..",
      position: "top",
      status: "info",
      isClosable: true,
      duration:500
    });
    const params = {
      columnKeys: caseView.reduce((c, i) => {
        return [...c, i.value];
      }, []),
      processCellCallback: (param) => {
        if (
          dateColumns.includes(param.column.colId) &&
          !isNaN(new Date(param.value))
        ) {
          return format(new Date(param.value), "dd-MMM-yyyy");
        }
        return param.value;
      },
      fileName: "cases.csv",
    };
    gridApi.exportDataAsCsv(params);
    return;
  };

  const onSearch = async (search='')=>{
    setisLoading(true);
    if(search === ''|| search === null){
      setRowData(oldCaseData);
      setisLoading(false);
      return;
    }
    let data = await CaseService.search({view:'week',q:search});
    if (data.error) {
      toast({
        title: data.error,
        position: "top",
        status: "error",
        isClosable: true,
      });
      setisLoading(false);
      return;
    } 
    if (data.warning) {
      toast({
        title: data.warning,
        position: "top",
        status: "warning",
        isClosable: true,
      });
      setisLoading(false);
      return;
    }
    setRowData(data);
    setisLoading(false);
  }

  let editClass = {
    'align-items': 'center',
    'justify-content': 'center',
    'display': 'flex'
  }
  return (
    <Box>
      <Flex>
        <Box>
          <Sidebar />
        </Box>
        <Box w="100%">
          <Loader isLoading={isLoading} />
          <Header>
            <CaseAction setisLoading={setisLoading} gridApi={gridApi} view={'week'} actionList={actionList}/>
            <CommentSearch onSearch={onSearch}/>
            <Divider pr={2} h="60px" orientation="vertical" />
            <DateRangeSelectorForWeeklyView  
              startDate = {new Date()}
              endDate = {new Date()}
              handleSubmit = {fetchData}
            />
            <Divider pr={2} h="60px" orientation="vertical" />
            <Button
              m={2}
              fontSize={".8rem"}
              borderWidth={"1px"}
              borderColor={"rgb(94,94,114,.3)"}
              size="md"
              rightIcon={<Icon as={FaFileCsv} />}
              onClick={exportAsCSV}
            >
              Export as CSV
            </Button>
          </Header>
          <Flex pl="2" pb="2">
            <BreadCrumbs />
            <Spacer />
            <Flex pr={5} style={{'display': 'flex','justifyContent': 'center', 'alignItems': 'center'}} >
              <Text pr={2} >Weekly View </Text>
              <Switch id="caseViewSwitch" isChecked={true} onChange={(e)=> {history.push('cases')}} />
            </Flex>
          </Flex>
          <Box>
            <Grid minH="87vh" pl={3} pr={2}>
              <VStack spacing={8}>
                <Box
                  style={{ height: "100%", width: "100%" }}
                  className="ag-theme-alpine"
                >
                  {isOpen && (
                    <CreateCaseForm
                      isOpen={isOpen}
                      onOpen={onOpen}
                      onClose={onClose}
                      merchant={selectedcase}
                      action="view"
                      updateChange={updateCase}
                    />
                  )}
                  <AgGridReact
                    rowData={caseData}
                    rowSelection={"multiple"}
                    groupSelectsChildren={true}
                    suppressRowClickSelection={true}
                    frameworkComponents={{
                      createCase: CreateCaseButton,
                      createTriggerTypes: (params)=>{
                      return(
                        <Box>
                          {params.data && params.data.selectedColumns.map(d=>(
                            <Box key={d.value} className={'triggerTypesDiv'}> <Text>{d.value} : {d.triggerValue
                                ? !isNaN(d.triggerValue) 
                                  ? 
                                    d.datatype === 'percentage' 
                                    ?
                                      d.isExactValueRequired       
                                      ?
                                        `${(d.triggerValue * 100).toFixed(2)}%`
                                      :
                                        `${Math.round(d.triggerValue * 100)}%` 
                                    :
                                      d.datatype === 'currency'
                                      ?   
                                        `${d.symbol}${thousandSeparator(d.triggerValue)}`
                                      :
                                        thousandSeparator(d.triggerValue)
                                  : 
                                    d.triggerValue
                                : 
                                  ""
                              } </Text></Box>
                          ))
                          }
                        </Box>
                      )
                    }
                    }}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={17}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    //onSelectionChanged={onSelectionChanged}
                    getRowNodeId={(data) => data._id}
                    groupUseEntireRow={true}
                  >
                   {actionList.length>1 &&
                    <AgGridColumn
                      width={50}
                      sortable={false}
                      filter={false}
                      headerCheckboxSelection={true}
                      checkboxSelection={true}
                      headerCheckboxSelectionFilteredOnly={true}
                      lockPosition={true}
                      pinned="left"
                    />
                   }
                    <AgGridColumn
                      width={50}
                      cellRenderer="createCase"
                      cellRendererParams={{ onClick: openModal, label: "view" }}
                      sortable={false}
                      filter={false}
                      lockPosition={true}
                      pinned="left"
                      cellStyle={editClass}
                    />
                    <AgGridColumn field="week" rowGroupIndex={0} hide={true} />
                    {/* <AgGridColumn field="trigerType" rowGroupIndex={2} hide={true} /> */}
                    <AgGridColumn                       
                      headerName="Case Id"
                      field="_id" 
                      cellStyle={dynamicCellStyle} 
                      lockPosition={true}
                    />
                    <AgGridColumn
                      field="Merchant Legal Name"
                      cellStyle={dynamicCellStyle}
                      lockPosition={true}
                    />
                    <AgGridColumn
                      field="Merchant"
                      rowGroupIndex={1}
                      cellStyle={dynamicCellStyle}
                      lockPosition={true}
                    />
                      <AgGridColumn
                      headerName="Trigger Types"
                      //field="triggerTypes"
                      cellRenderer="createTriggerTypes"
                      autoHeight={true}
                      wrapText={true}
                      lockPosition={true}
                      rowSpan={rowSpan}
                      width={320}
                      //cellClassRules={'triggerTypes'}
                    />
                    <AgGridColumn
                      headerName="Manager"
                      field="manager"
                      cellStyle={dynamicCellStyle}
                    />
                    <AgGridColumn
                      headerName="Uploaded Date"
                      field="uploadedDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn 
                      headerName="Status" 
                      field="status" 
                      cellStyle={dynamicCellStyle}   
                    />
                    <AgGridColumn
                      headerName="File Date"
                      field="fileDate"
                      cellStyle={dynamicCellStyle}
                      comparator={dateComparator}
                      cellRenderer={cellUpdateForDate}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Created Date"
                      field="createdDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Reminder Date"
                      field="reminderDate"
                      cellStyle={dynamicCellStyle}
                      cellRenderer={cellUpdateForDate}
                      comparator={dateComparator}
                      filter="agDateColumnFilter"
                      filterParams={filterParams}
                    />
                    <AgGridColumn
                      headerName="Country"
                      field="fileCountry"
                      cellRenderer={cellUpdateForCountry}
                      cellStyle={dynamicCellStyle}
                    />
                  </AgGridReact>
                </Box>
              </VStack>
            </Grid>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default ListCasesWeeklyGroup;

function rowSpan(params) {
  if (params.data && params.data.selectedColumns && params.data.selectedColumns.length) {
    return params.data.selectedColumns.length;
  } else {
    return 1;
  }
}